export async function getSymbolPrice(symbol) {
    try {
        const { rows } = await fetch(
            `https://bors.e24.no/server/components?columns=ITEM_SECTOR,LASTNZ,TIME&itemSector=${symbol}`
        ).then(res => res.json());

        const { values: tickerData } = rows[0];

        return tickerData.LASTNZ;
    } catch (e) {
        return null;
    }
}
